/**
 * VELUNE — Desktop product gallery variant image fix
 *
 * The theme's mobile carousel correctly selects the variant's featured image.
 * Desktop uses a CSS grid, so carousel.select() cannot bring that image into
 * view. We handle the variant:change event directly and reorder/filter the
 * desktop grid without changing mobile behavior.
 */
(function () {
  const applyDesktopVariantImage = (event) => {
    const variant = event.detail?.variant;
    const product = event.detail?.product;
    if (!variant?.featured_media || !product?.media) return;

    document.querySelectorAll("product-gallery").forEach((gallery) => {
      const carousel = gallery.querySelector('media-carousel[desktop-mode="grid"], media-carousel[desktop-mode="grid_highlight"]');
      if (!carousel) return;

      const selectedPosition = variant.featured_media.position;
      const otherVariantPositions = new Set(
        (product.variants || [])
          .filter((item) => item.id !== variant.id && item.featured_media)
          .map((item) => item.featured_media.position)
      );

      carousel.querySelectorAll(".product-gallery__media").forEach((mediaEl, index) => {
        const position = index + 1;
        const isSelected = position === selectedPosition;
        const belongsToOtherVariant = otherVariantPositions.has(position);

        mediaEl.hidden = belongsToOtherVariant && !isSelected;
        mediaEl.style.order = isSelected ? "-9999" : "0";
      });
    });
  };

  document.addEventListener("variant:change", (event) => {
    if (!window.matchMedia("(min-width: 1000px)").matches) return;
    requestAnimationFrame(() => applyDesktopVariantImage(event));
  });
})();